export const excludedKeys = ['Esc', 'CapsLock', 'Shift', 'Control', 'Alt', 'Meta', 'Backspace', 'Enter'];